var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value || _vm.detail)?_c('tr',{class:{ 'text--secondary': _vm.secondary }},[_c('td',[_vm._v(_vm._s(_vm.title))]),_c('td',{staticClass:"text-right"},[(_vm.value)?_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.value)))]):_vm._e(),(_vm.detail)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.detail))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }